import { Component, ChangeDetectorRef } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalConfig,
} from "@ng-bootstrap/ng-bootstrap";
import { HttpService } from "../../service/HTTPService/HttpService";
import { environment } from "../../../environments/environment";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { Globals } from "../../globals";
import { ApiService } from "../../service/apiUrls/apiUrl.service";

@Component({
  selector: "app-actions-cell",
  template: `<select
      style="height: 29px;font-size: 13px;width: 96px;margin-top: -4px;"
      class="form-control"
      [(ngModel)]="selectedoption"
      (change)="
        optionChanged($event.target.value, autoEnableModal, autoDisableModal)
      "
      name="sel2"
    >
      <option class="newOption" value="Action" disabled selected>Action</option>
      <option *ngFor="let options of optionArr" [value]="options.name">
        {{ options.name }}
      </option>
    </select>
    <ng-template #autoEnableModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Enable Automation</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form name="enableForm" #enableForm="ngForm">
          <div
            *ngFor="let option of enableArr"
            style="float: left;padding-right: 20px;"
          >
            <input
              #enableOption
              type="radio"
              name="gender"
              value="{{ option.name }}"
              (change)="
                onChange('enable', $event.target.checked, enableOption.value)
              "
            />
            {{ option.name }}<br />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          value="enableClick"
          (click)="modal.dismiss('enable')"
        >
          Process
        </button>
      </div>
    </ng-template>
    <ng-template #autoDisableModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Disable Automation</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form name="disableForm" #disableForm="ngForm">
          <div
            *ngFor="let option1 of disableArr"
            style="float: left;padding-right: 20px;"
          >
            <input
              #disableOption
              type="radio"
              name="gender"
              value="{{ option1.name }}"
              (change)="
                onChange('disable', $event.target.checked, disableOption.value)
              "
            />
            {{ option1.name }}<br />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          value="disableClick"
          (click)="modal.dismiss('disable')"
        >
          Process
        </button>
      </div>
    </ng-template> `,
  styles: [
    `
      .modal-footer button {
        width: 150px !important;
      }
    `,
  ],
})
export class EquipmentCmdActionRendererComponent
  implements ICellRendererAngularComp
{
  selectedoption = "Action";
  closeResult: string;
  public params: any;
  public sid = "";
  generatorMode = "";
  ac1mode = "";
  ac2mode = "";
  generatorVal = "";
  ac1Val = "";
  ac2Val = "";
  optionArr = [];
  enableArr = [];
  disableArr = [];
  enableAutomationMode = false;
  displaygeneratorAuto = false;
  displayac1Auto = false;
  displayac2Auto = false;
  mode = "";
  selectedMode = "";

  constructor(
    private modalService: NgbModal,
    config: NgbModalConfig,
    private cdr: ChangeDetectorRef,
    private http: HttpService,
    private globals: Globals,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService
  ) {
    config.backdrop = "static";

  }
  agInit(params: any): void {
    this.params = params;
    this.sid = this.params.data.SiteID;
    this.generatorMode = this.params.data.generator;
    this.ac1mode = this.params.data.AC1Mode;
    this.ac2mode = this.params.data.AC2Mode;
    this.generatorVal = this.params.data.generatorVal;
    this.ac1Val = this.params.data.AC1Val;
    this.ac2Val = this.params.data.AC2Val;
    this.optionArr = [];
    this.disableArr = [];
    this.enableArr = [];
    if (this.generatorMode == "Auto") {
      this.displaygeneratorAuto = true;
    }
    if (this.ac1mode == "Auto") {
      this.displayac1Auto = true;
    }
    if (this.ac2mode == "Auto") {
      this.displayac2Auto = true;
    }
    if (
      this.generatorMode == "Auto" ||
      this.ac1mode == "Auto" ||
      this.ac2mode == "Auto"
    ) {
      this.enableAutomationMode = false;
    }
    if (
      this.generatorMode == "Manual" ||
      this.ac1mode == "Manual" ||
      this.ac2mode == "Manual"
    ) {
      this.enableAutomationMode = true;
    }
    if (
      this.displaygeneratorAuto &&
      this.displayac1Auto &&
      this.displayac2Auto
    ) {
      this.disableArr.push(
        { name: "Generator" },
        { name: "AC 1" },
        { name: "AC 2" }
      );
      this.optionArr.push({ name: "Disable Automation" });
    } else if (
      this.displaygeneratorAuto &&
      this.displayac1Auto &&
      !this.displayac2Auto
    ) {
      this.enableArr.push({ name: "AC 2" });
      this.disableArr.push({ name: "Generator" }, { name: "AC 1" });
      this.optionArr.push(
        { name: "Enable Automation" },
        { name: "Disable Automation" },
        { name: "AC2 Start" },
        { name: "AC2 Stop" }
      );
    } else if (
      this.displaygeneratorAuto &&
      !this.displayac1Auto &&
      !this.displayac2Auto
    ) {
      this.enableArr.push({ name: "AC 1" }, { name: "AC 2" });
      this.disableArr.push({ name: "Generator" });
      this.optionArr.push(
        { name: "Enable Automation" },
        { name: "Disable Automation" },
        { name: "AC1 Start" },
        { name: "AC1 Stop" },
        { name: "AC2 Start" },
        { name: "AC2 Stop" }
      );
    } else if (
      !this.displaygeneratorAuto &&
      !this.displayac1Auto &&
      !this.displayac2Auto
    ) {
      this.enableArr.push(
        { name: "Generator" },
        { name: "AC 1" },
        { name: "AC 2" }
      );
      this.optionArr.push(
        { name: "Enable Automation" },
        { name: "Generator Start" },
        { name: "Generator Stop" },
        { name: "AC1 Start" },
        { name: "AC1 Stop" },
        { name: "AC2 Start" },
        { name: "AC2 Stop" }
      );
    } else if (
      !this.displaygeneratorAuto &&
      this.displayac1Auto &&
      this.displayac2Auto
    ) {
      this.enableArr.push({ name: "Generator" });
      this.disableArr.push({ name: "AC 1" }, { name: "AC 2" });
      this.optionArr.push(
        { name: "Enable Automation" },
        { name: "Disable Automation" },
        { name: "Generator Start" },
        { name: "Generator Stop" }
      );
    } else if (
      !this.displaygeneratorAuto &&
      !this.displayac1Auto &&
      this.displayac2Auto
    ) {
      this.enableArr.push({ name: "Generator" }, { name: "AC 1" });
      this.disableArr.push({ name: "AC 2" });
      this.optionArr.push(
        { name: "Enable Automation" },
        { name: "Disable Automation" },
        { name: "Generator Start" },
        { name: "Generator Stop" },
        { name: "AC1 Start" },
        { name: "AC1 Stop" }
      );
    } else if (
      this.displaygeneratorAuto &&
      !this.displayac1Auto &&
      this.displayac2Auto
    ) {
      this.enableArr.push({ name: "AC 1" });
      this.disableArr.push({ name: "Generator" }, { name: "AC 2" });
      this.optionArr.push(
        { name: "Enable Automation" },
        { name: "Disable Automation" },
        { name: "AC1 Start" },
        { name: "AC1 Stop" }
      );
    } else if (
      !this.displaygeneratorAuto &&
      this.displayac1Auto &&
      !this.displayac2Auto
    ) {
      this.enableArr.push({ name: "Generator" }, { name: "AC 2" });
      this.disableArr.push({ name: "AC 1" });
      this.optionArr.push(
        { name: "Enable Automation" },
        { name: "Disable Automation" },
        { name: "Generator Start" },
        { name: "Generator Stop" },
        { name: "AC2 Start" },
        { name: "AC2 Stop" }
      );
    }
  }
  refresh(): boolean {
    return false;
  }
  onChange(name: string, isChecked: boolean, value) {
    if (isChecked && name.includes("enable")) {
      this.mode = "enable";
      this.selectedMode = value;
    }
    if (isChecked && name.includes("disable")) {
      this.mode = "disable";
      this.selectedMode = value;
    }
  }
  optionChanged(option, enableModal, disableModal) {
    this.selectedoption = "";
    this.cdr.detectChanges();
    if (option == "Enable Automation") {
      this.selectedoption = "Action";
      this.openModal(enableModal);
    } else if (option == "Disable Automation") {
      this.selectedoption = "Action";
      this.openModal(disableModal);
    } else if (option == "Generator Start") {
      this.selectedoption = "Action";
      this.toSendDGCommand(1);
    } else if (option == "Generator Stop") {
      this.selectedoption = "Action";
      this.toSendDGCommand(0);
    } else if (option == "AC1 Start") {
      this.selectedoption = "Action";
      this.toSendACCommand(1, 1, 1);
    } else if (option == "AC1 Stop") {
      this.selectedoption = "Action";
      this.toSendACCommand(1, 0, 1);
    } else if (option == "AC2 Start") {
      this.selectedoption = "Action";
      this.toSendACCommand(2, 1, 2);
    } else if (option == "AC2 Stop") {
      this.selectedoption = "Action";
      this.toSendACCommand(2, 0, 2);
    }
  }
  toSendACCommand(status, choice, pin) {
    const getJson = {
      SiteID: this.sid,
      Status: status,
      Choice: choice,
      Time: 0,
      Pin: pin,
    };
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.AirconStartStopURL,
        getJson
      )
      .subscribe(
        (res) => {
          const getResp: string = JSON.stringify(res.body);
          this.setMessage(getResp, "info");
        },
        (error) => {
          console.error(error);

          this.setMessage("Could not send Email, Please try again", "danger");
        }
      );
  }
  toSendDGCommand(mode) {
    const getJson = {
      SiteID: this.sid,
      Mode: mode,
      Options: 1,
    };
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.generatorStartStopURL,
        getJson
      )
      .subscribe(
        (res) => {
          const getResp: string = JSON.stringify(res.body);
          this.setMessage(getResp, "info");
        },
        (error) => {
          console.error(error);

          this.setMessage("Could not send Email, Please try again", "danger");
        }
      );
  }
  /**
   * To open the Export Modal
   * @param content
   */
  openModal(content) {
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else if (reason.includes("enable")) {
      if (this.selectedMode == "Generator") {
        this.sendModeCmd();
      }
    } else if (reason.includes("disable")) {
      if (this.selectedMode == "Generator") {
        this.sendModeCmd();
      }
    } else {
      return `with: ${reason}`;
    }
  }

  sendModeCmd() {
    let mode = 0;
    if (this.mode == "enable") {
      mode = 1;
    } else if (this.mode == "disable") {
      mode = 2;
    }
    const jsonData = {
      SiteID: this.sid,
      Options: 2,
      Mode: mode,
    };
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.sendModeCmdURL,
        jsonData
      )
      .subscribe(
        (res) => {
          const getResp: string = JSON.stringify(res.body);
          this.setMessage(getResp, "info");
        },
        (error) => {
          console.error(error);
        }
      );
  }
  acknowledge(comment) {
    if (comment != "") {
      const jsonData = {
        Description: comment,
      };

      this.http
        .post(
          this.urlAuthentication.itocUrl + this.apiUrl.actionAckUrl,
          jsonData
        )
        .subscribe(
          (res) => {
            const getImgResp: string = JSON.stringify(res.body);
            if (getImgResp.includes("Alarm Acknowledged.")) {
              this.setMessage(
                "Acknowledged and Description updated",
                "success"
              );
            } else {
              this.setMessage(
                "Acknowledgement failed !!!, Please try again",
                "danger"
              );
            }
          },
          (error) => {
            console.error(error);

            this.setMessage(
              "Acknowledgement failed !!!, Please try again",
              "danger"
            );
          }
        );
    } else {
      this.setMessage(
        "Alarm Description should not be empty, Please try again",
        "danger"
      );
    }
  }

  setMessage(msg, type) {
    this.globals.message = "";
    this.globals.messageType = "";
    this.globals.message = msg;
    this.globals.messageType = type;
    this.params.context.componentParent.ngBeforeViewInit();
  }
}
